import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { BoardLetterValidate, LetterShowClick, UniversityLetterValidate } from '../../../../config/Validate';
import { defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../../appconfig/Settings';
import { getAllDetailsDirect, getSpecificDetailsById, postAllData } from '../../../../service/ProductService';
import { DOWNLOADRUHSLETTER, DOWNLOADVERIFICATIONLETTER, LETTERMASTERBOARDSLIST, STOREVERIFICATION, VERIFICATION } from '../../../../config/ApiConstant';
import { AddBoardLetterListColumns, AddUniversityLetterListColumns } from '../../../../appconfig/DatatableSetting';
import { commonNameTemplate, dateTemplate } from '../../../../appconfig/DatatableTemplateSetting';
import { VerificationTab } from '../VerificatuionTab';
import { LettersTab } from '../../LettersTab';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import Loader from '../../../../components/Loadeer/Loader';

export const BoardLetter = () => {
    document.title = ' Verificatio Board Letter | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [regNo, setRegNo] = useState<any>(null);
    const [boardData, setBoardData] = useState<any>({});
    const [addLoader, setAddLoader] = useState<boolean>(false);
    const [boardList, setBoardList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [buttonVisible, setButtonVisible] = useState<boolean>(true);
    const [boardOptions, setBoardOptions] = useState<any>([]);

    // useEffect
    useEffect(() => {
        getBoardLetter();
        getAllBoardList();
    }, []);

    // Get Boatd
    const getAllBoardList = async () => {
        try {
            const response = await getAllDetailsDirect(LETTERMASTERBOARDSLIST + '?type=all');

            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setBoardOptions([]);
                } else {
                    let boardData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const boardObj: any = {};
                        boardObj['name'] = DataList[i].BoardNm;
                        boardObj['code'] = DataList[i].SrNo;
                        boardData.push(boardObj);
                    }
                    setBoardOptions(boardData);
                }
            } else {
                setBoardOptions([]);
            }
        } catch (error: any) {
            setBoardList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined"></Button>
            </>
        );
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'board') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }

        setBoardData({ ...boardData, [name]: val });
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Clear all
    const clearAll = () => {
        setRegNo(null);
        setBoardData({});
        setErrors({});
    };

    // getUniversitLetterList
    const getBoardLetter = async () => {
        if (!window.cn(regNo)) {
            try {
                const response = await getAllDetailsDirect(VERIFICATION + '?VerificationBy=Board' + '&FileNo=' + regNo + '&search=' + '');
                const { List } = response;
                if (!window.cn(response) && Object.keys(response?.Details).length !== 0) {
                    const { StudF, StudM, StudL } = response?.Details;
                    let FromNm = (!window.cn(StudL) ? StudL : '') + ' ' + (!window.cn(StudF) ? StudF : '') + ' ' + (!window.cn(StudM) ? StudM : '');
                    setBoardData({
                        Name: FromNm
                    });
                    setBoardList(List);
                    setShowLoading(false);
                    setButtonVisible(false);
                } else {
                    setButtonVisible(true);
                    setShowLoading(false);
                    setBoardData({ ...boardData });
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast
                    setShowLoading(false);
                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        } else {
            try {
                setPageLoad(false);
                const response = await getAllDetailsDirect(VERIFICATION + '?VerificationBy=Board' + '&search=' + '');

                if (response) {
                    const { List } = response;
                    setBoardList(List);
                    setPageLoad(true);
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast
                    setPageLoad(true);

                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        }
    };

    // onShowClick get User Deatsils
    const getUserDetails = async () => {
        try {
            const { errors, isError } = LetterShowClick(regNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setShowLoading(true);
                // setPageLoad(false);

                getBoardLetter();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setShowLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    // Add inward data
    const addboardData = async () => {
        try {
            const { errors, isError } = BoardLetterValidate(boardData, regNo);
            setErrors(errors);
            //Check Error if no errors then call API
            if (!isError) {
                setAddLoader(true);

                const requestData = {
                    FileNo: Number(regNo),
                    IdUniBordCol: boardData?.board?.code,
                    UniBordCol: boardData?.board?.name,
                    Name: boardData?.Name,
                    ToAddress: boardData?.ToAddress,
                    VerificationBy: 'Board'
                };

                const response = await postAllData(STOREVERIFICATION, requestData);
                if (response) {
                    setAddLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Message', detail: response?.data });
                    setBoardData({});
                    clearAll();
                    getBoardLetter();
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setAddLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button icon="pi pi-download" onClick={() => downloadBoardLetter(rowData?.SrNo)} tooltip="Download" tooltipOptions={{ position: 'top' }} />
                </div>
            </>
        );
    };

    // Download bank entry
    const downloadBoardLetter = async (id: any) => {
        try {
            setLoading(true);

            const response = await getSpecificDetailsById(DOWNLOADVERIFICATIONLETTER, id);

            //Check response and download
            if (response) {
                //PDF Download
                const { file_url } = response;
                setLoading(false);

                //PDF Download
                const fileName = `Verification-Board-letter-${new Date().getTime()}.pdf`;
                const link = document.createElement('a');
                link.href = file_url;
                link.target = '_blank';
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <LettersTab mainTabLabel="Verification Letters" />
            <VerificationTab initialTabLabel="Board Verification Letters" />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid align-items-center">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    File No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(regNo) ? regNo : ''} name="regNo" keyfilter="num" autoComplete="off" placeholder="Enter File No." onChange={(e) => setRegNo(e.target.value)} className={errors['regNo'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['regNo']}</small>
                            </div>
                            <div className="field col-12 md:col-1 mt-4">
                                <Button label="Search" className="p-button-primary" onClick={() => getUserDetails()} loading={showLoading} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="Name">
                                    Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(boardData?.Name) ? boardData?.Name : ''} name="Name" disabled={true} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="RollNo">
                                    Board <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Dropdown
                                    value={boardData?.board}
                                    name="board"
                                    options={boardOptions}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select Board"
                                    onChange={(e) => onInputChange(e.value, 'board')}
                                    className={errors['board'] && 'p-invalid'}
                                />
                                <small className="p-invalid-txt">{errors['board']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="ToAddress">Address</label>
                                <InputTextarea value={!window.cn(boardData?.ToAddress) ? boardData?.ToAddress : ''} className={errors['ToAddress'] && 'p-invalid'} name="ToAddress" rows={4} onChange={(e) => onInputChange(e, 'ToAddress')} />
                                <small className="p-invalid-txt">{errors['ToAddress']}</small>
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="Clear" icon="pi pi-times" className="p-button-secondary mr-2" onClick={() => clearAll()} />
                                    <Button label="Save" icon="pi pi-check" onClick={() => addboardData()} loading={addLoader} disabled={buttonVisible} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={boardList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={boardList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {AddBoardLetterListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'created_at') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'UniBordCol') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} />;
                                        } else if (col.field === 'ToAddress') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} />;
                                        } else if (col.field === 'FileNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} style={{ minWidth: '8rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {AddBoardLetterListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {loading === true ? <Loader /> : ''}
        </>
    );
};
